module.exports = __webpack_public_path__ + "img/projects_color.9fcd25a9.svg";